export enum KeySymbol {
  Command = '⌘',
}
